import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { FaCheck, FaTimes } from "react-icons/fa";

const SuccessModal = ({ show, handleClose, modalData, performFunction }) => {

  return (
    <div className="report-modal">
      <Modal
        show={show}
        onHide={handleClose}
        size="md"
        centered
      >
        <Modal.Header className="modal-header-custom">
          {modalData?.status === "success" ?
            <FaCheck className="success-icon" />
            :
            <FaTimes className="error-icon" />
          }

          {/* <button type="button" className="close-btn" onClick={handleClose}>
            &times;
          </button> */}
        </Modal.Header>

        <Modal.Body className="report-modal-body">
          <Row className="justify-content-center">
            <Col md="10" className="mx-auto my-auto">

              <Modal.Title className="success-modal-title">
                {modalData?.header}
              </Modal.Title>
              <div>
                <p className="success-modal-content">{modalData?.content}</p>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <Button
                  type="button"
                  className="btn-shadow vs-button-css px-4 py-2"
                  size="md"
                  onClick={() => performFunction()}
                >
                  Ok
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SuccessModal;

